__turbopack_context__.v({
  "container": "YourWishlist-module__fGCyXq__container",
  "content": "YourWishlist-module__fGCyXq__content",
  "favourited": "YourWishlist-module__fGCyXq__favourited",
  "prizeFlexItem": "YourWishlist-module__fGCyXq__prizeFlexItem",
  "prizes": "YourWishlist-module__fGCyXq__prizes",
  "prizesDesktopColumn": "YourWishlist-module__fGCyXq__prizesDesktopColumn",
  "prizesDesktopRow": "YourWishlist-module__fGCyXq__prizesDesktopRow",
  "suggested": "YourWishlist-module__fGCyXq__suggested",
  "suggestedButton": "YourWishlist-module__fGCyXq__suggestedButton",
  "suggestedTitle": "YourWishlist-module__fGCyXq__suggestedTitle",
  "wishlistImageOverlay": "YourWishlist-module__fGCyXq__wishlistImageOverlay",
});
